import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import BasketballMatchLineupStore from './store';
import {
  Container,
  SelectedTab,
  SelectTabContainer,
  SelectTabWrapper
} from './styled';
import StartPlayer from './StartPlayer';
import ReadyPlayer from './ReadyPlayer';
import ImpossiblePlayer from './ImpossiblePlayer';

const BasketballLineup = () => {
  let { id } = useParams();
  const { getLineup, data } = BasketballMatchLineupStore();
  const [selectedTeam, setSelectedTeam] = useState('home');

  useEffect(() => {
    getLineup(id);
  }, []);

  const onClickTab = (team) => {
    setSelectedTeam(team);
  };

  const teamData = useMemo(() => {
    if (selectedTeam === 'home') {
      return {
        selection: data.selection.home,
        candidate: data.candidate.home,
        impossible: data.impossible.home
      };
    } else {
      return {
        selection: data.selection.away,
        candidate: data.candidate.away,
        impossible: data.impossible.away
      };
    }
  }, [selectedTeam, data.selection, data.candidate]);

  return (
    <Container>
      <SelectTabContainer>
        <SelectTabWrapper>
          <SelectedTab
            isSelected={selectedTeam === 'home'}
            onClick={() => onClickTab('home')}
          >
            홈
          </SelectedTab>
          <SelectedTab
            isSelected={selectedTeam === 'away'}
            onClick={() => onClickTab('away')}
          >
            원정
          </SelectedTab>
        </SelectTabWrapper>
      </SelectTabContainer>
      <StartPlayer data={teamData.selection} />
      <ReadyPlayer data={teamData.candidate} />
      <ImpossiblePlayer data={teamData.impossible} />
    </Container>
  );
};

export default BasketballLineup;
